import Vue from 'vue'
import message from '@/constant/message'
import sign from '@/constant/sign'
const Constant = { ...message, ...sign }

Vue.prototype.$constant = Constant

export default Constant
